import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import { FcOpenedFolder } from 'react-icons/fc';

interface IExcelFileDialogProps {
    dialogName: string;
    handleGenerateReport?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
}

const ExcelFileDialog = (props: IExcelFileDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ExcelFileDialog onCreate()');
    };

    const OKClicked = () => {
        let values = getValues();

        alert('Excel export not implemented. Chosen options:' + values);

        props.hideDialog();
    };

    return (
        <Dialog title="Excel File" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        name={`excelFile.reportType`}
                        label="Report Type"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={[
                            { value: '1', label: `Current Manager's Projects` },
                            { value: '1', label: `Current Manager/Client Projects` },
                            { value: '1', label: `Current Project` },
                            { value: '1', label: `Current Billing Item` }
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem' }}
                    />
                    <div className="form-row">
                        <RHFInputBox
                            label="Filename"
                            labelOnLeft={true}
                            labelStyle={{ width: '17rem', margin: '0'}}
                            name={`excelFile.filename`}
                            type="file"
                            register={register}
                            errors={errors}
                            style={{ width: '100%', margin: '0' }}
                            bodyStyle={{ width: '40rem' }}
                        />
                    </div>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ whiteSpace: 'nowrap', width: '26%', marginRight: '1rem' }}
                    text={'Generate Report'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
                </Dialog>
    );
};

export default ExcelFileDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/ExcelFileDialog.tsx